import _extends from "@babel/runtime-corejs2/helpers/extends";
import * as React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import Icon from '../../components/Icon';
export var Breadcrumbs = function Breadcrumbs(props) {
  return /*#__PURE__*/React.createElement(Breadcrumb, _extends({
    divider: props.sections ? /*#__PURE__*/React.createElement(Icon, {
      name: "chevron-right"
    }) : undefined
  }, props));
};
export default Breadcrumbs;